// @ts-nocheck

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { createReducer } from 'Helpers/redux'
import { Roles } from 'Constants/enums'
import { CHANGE_PAYPAL, CHANGE_EMAIL } from 'Redux/actions/settingsActions'
import {
  CREATE_CAMPAIGN_WITHOUT_SIGNUP,
  UPDATE_NUMBER_FROM_STATE,
} from 'Redux/actions/campaignActions'
import { SET_CURATOR_SCORE } from 'Redux/actions/reviewsActions'
import {
  SIGN_IN,
  SIGN_IN_SPOTIFY,
  UPDATE_TOKEN,
  REHYDRATE_TOKEN,
  LOG_OUT,
  SIGN_UP_ARTIST,
  SIGN_UP_CURATOR,
  SET_ROLE_TO_USER,
  ACCEPT_TERMS,
  ACCEPT_TERMS_NEW,
  CONFIRM_EMAIL,
  SIGN_IN_AS,
  SET_IS_FIRST_CAMPAIGN,
  GET_CURATOR_RANK,
  SET_PLAYLIST_REQUIREMENT,
  GET_USER_INFO,
  UPDATE_ARTIST,
  CHECK_USER_EMAIL_TO_SIGN_IN,
  SET_LOGIN_TYPE_TO_INITIAL_STATE,
  GET_SPOTIFY_AVATAR,
  SET_COMPLAINTS_READ,
  GET_CURRENCY,
  GET_COUNTRY,
  ACTIVATE_CURATOR,
  SET_GCID_TO_USER,
  SET_IS_NEW_FEED,
  SET_IS_FEED_BANNER,
  RESET_USER_BALANCE,
} from 'Redux/actions/auth'
import {
  APPLICANT_CONFIRM_EMAIL,
  SET_TOKEN,
  USERS_ME,
} from 'Redux/actions/influencerActions'

import { SEND_RELEASE_NOTES_READ } from '../actions/usersActions'

const initialState = {
  error: null,
  credentials: {},
  user: {},
  currency: { name: 'USD', rate: 1 },
  isArtist: null,
  isPassword: false,
  isEmailBounced: false,
  authType: 'login',
  isBlocked: false,
  verified: false,
  tiktokProfile: null,
  transitForCreds: {},
  is_new_term: false,
  curator_id: null,
}

const persistConfig = {
  key: 'auth',
  storage,
  blacklist: ['error'],
}

const handlers = {
  [GET_SPOTIFY_AVATAR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      user_photo_url: payload.new_avatar_image,
    },
  }),
  [SIGN_IN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    role: payload.role,
    isArtist: payload.isArtist,
    user: payload.user,
  }),

  [CREATE_CAMPAIGN_WITHOUT_SIGNUP.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role ?? prevState.role,
    user: payload.user,
  }),

  [SIGN_IN_SPOTIFY.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role,
    user: payload.user,
    userID: payload.user_id,
  }),

  [APPLICANT_CONFIRM_EMAIL.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload,
    },
    role: Roles.influencer,
  }),

  [SET_ROLE_TO_USER.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role ?? prevState.role,
    user: payload.user,
  }),
  [SIGN_UP_ARTIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role,
    user: payload.user,
  }),
  [GET_USER_INFO.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    isPassword: payload.isPassword,
    isEmailBounced: payload.isEmailBounced,
    isBlocked: payload.is_blocked,
    userID: payload.user_id,
    verified: payload.curator ? payload.curator.verified : null,
    phone_number: payload.phone_number,
    curator_id: payload?.curator?.id,

    user: {
      ...prevState.user,
      user_photo_url: payload.user_photo_url,
      release_notes: payload.release_notes,
      balance: payload.balance,
      userID: payload.user_id,
      complaints: payload.complaints,
      isDeactivated: payload.isDeactivated,
      country: payload.country,
      first_name: payload.curator
        ? payload.curator.first_name
        : prevState.user.first_name,
      last_name: payload.curator
        ? payload.curator.last_name
        : prevState.user.last_name,
      are_terms_accepted: payload.curator
        ? payload.curator.are_terms_accepted
        : null,
      terms_position: payload.curator ? payload.curator.terms_position : null,
      spotifyId: payload.curator ? payload.curator.spotify_id : null,
      is_email_confirmed: payload.is_email_confirmed,
      curatorId: payload.curator ? payload.curator.id : null,
      is_new_feed: payload?.curator?.is_new_feed,
      is_feed_banner: payload?.curator?.is_feed_banner,
    },
  }),

  [SET_IS_NEW_FEED.SUCCESS]: prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      is_new_feed: false,
    },
  }),

  [SET_IS_FEED_BANNER.SUCCESS]: prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      is_feed_banner: false,
    },
  }),

  [UPDATE_ARTIST.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      first_name: payload.first_name,
      last_name: payload.last_name,
      phone_number: payload.phone_number,
    },
  }),

  [UPDATE_NUMBER_FROM_STATE]: (prevState, { payload }) => ({
    ...prevState,
    phone_number: payload,
  }),

  [CHECK_USER_EMAIL_TO_SIGN_IN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    authType: payload.type,
  }),

  [SET_LOGIN_TYPE_TO_INITIAL_STATE]: prevState => ({
    ...prevState,
    authType: 'login',
  }),
  [ACCEPT_TERMS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      are_terms_accepted: payload.are_terms_accepted,
    },
  }),
  [ACCEPT_TERMS_NEW.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      are_terms_accepted: payload.are_terms_accepted,
    },
  }),
  [SET_GCID_TO_USER.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      gcid: payload.gcid,
    },
  }),
  [CONFIRM_EMAIL.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      is_email_confirmed: payload,
    },
  }),
  [SET_CURATOR_SCORE]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      score: payload.score,
      rank: payload.rank,
    },
  }),
  [SET_IS_FIRST_CAMPAIGN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      is_first_campaign: payload,
    },
  }),
  [SIGN_UP_CURATOR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role,
    user: payload.user,
  }),
  [UPDATE_TOKEN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      ...prevState.credentials,
      ...payload,
    },
  }),
  [REHYDRATE_TOKEN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: payload.data,
    user: payload.user,
    isArtist: payload.isArtist,
    role: payload.role === 'artists' ? Roles.artist : payload.role,
  }),
  [CHANGE_PAYPAL.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      paypal_email: payload,
    },
  }),
  [CHANGE_EMAIL.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    isEmailBounced: false,
    credentials: {
      AccessToken: payload.token,
    },
    user: {
      ...prevState.user,
      email: payload.email,
      is_email_confirmed: false,
    },
  }),
  [GET_CURATOR_RANK.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      rank: payload.rank,
      score: payload.score,
    },
  }),
  [SIGN_IN_AS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload.token,
    },
    isArtist: payload.isArtist,
    role: payload.role,
    user: payload.user,
  }),
  [SET_PLAYLIST_REQUIREMENT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      playlist_requirement: payload.playlist_requirement,
    },
  }),

  [LOG_OUT]: () => {
    localStorage.clear()
    window.location.replace('/')
  },

  [SET_COMPLAINTS_READ.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      complaints: payload === 'OK' ? 0 : prevState.user.complaints,
    },
  }),

  [GET_CURRENCY.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    currency: {
      name: payload.currency_rate > 0 ? payload.currency_name : 'USD',
      rate: payload.currency_rate > 0 ? payload.currency_rate : 1,
    },
  }),

  [GET_COUNTRY.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    country: payload.country_code,
  }),

  [ACTIVATE_CURATOR.SUCCESS]: prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      isDeactivated: false,
    },
  }),

  [SEND_RELEASE_NOTES_READ.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    user: {
      ...prevState.user,
      release_notes: payload === 'OK' ? null : payload.release_notes,
    },
  }),

  [SET_TOKEN]: (prevState, { payload }) => ({
    ...prevState,
    credentials: {
      AccessToken: payload,
    },
    role: Roles.influencer,
  }),

  [RESET_USER_BALANCE]: prevState => ({
    ...prevState,
    user: {
      ...prevState.user,
      balance: 0,
    },
  }),

  [USERS_ME.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    role: payload.role,
    user: {
      ...prevState.user,
      user_photo_url: payload.userPhotoUrl,
      id: payload.id,
      first_name: payload.firstName,
      last_name: payload.lastName,
      createdAt: payload.createdAt,
      updatedAt: payload.updatedAt,
      email: payload.email,
      spotifyId: payload.spotifyId,
      isEmailConfirmed: payload.isEmailConfirmed,
      lastActivity: payload.lastActivity,
    },
  }),
}

export default persistReducer(
  persistConfig,
  createReducer(initialState, handlers)
)
